import React from 'react';
import './ui.scss';

export const Input = ({ label, className = '', id, required, ...props }) => {
  const inputId = id || (label ? label.replace(/\s+/g, '-').toLowerCase() : undefined);
  return (
    <div className={`mb-2 ${className}`}>
      {label && (
        <label className="builder-label" htmlFor={inputId}>
          {label}
          {required && <span className="builder-label__required" aria-hidden="true">*</span>}
        </label>
      )}
      <input id={inputId} className="builder-ui-input form-control" required={required} {...props} />
    </div>
  );
};

export default Input;
